import { useRef, useState } from "react";
import type { AgentQuickPrompt } from "../../shared/types";

const PILL_CLASS = [
  // Shape and spacing
  "h-8 shrink-0 rounded-full px-4",
  // Surface
  "border border-[#E0E0E0] bg-white text-[#232323]",
  // Typography — never wrap a pill label
  "text-sm font-medium whitespace-nowrap",
  // Hover
  "cursor-pointer transition-colors hover:bg-[#F5F5F5]",
  // Focus ring (widget-wide convention)
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
  "focus-visible:ring-offset-2 focus-visible:ring-offset-white",
  // Disabled, once a prompt has been selected
  "disabled:cursor-not-allowed disabled:opacity-50",
].join(" ");

interface QuickPromptPillsProps {
  quickPrompts?: AgentQuickPrompt[];
  onSelect: (prompt: string, title: string) => void;
}

export function QuickPromptPills({
  quickPrompts,
  onSelect,
}: QuickPromptPillsProps) {
  const hasSelectedRef = useRef(false);
  const [isDisabled, setIsDisabled] = useState(false);

  if (!quickPrompts || quickPrompts.length === 0) {
    return null;
  }

  function handleSelect(quickPrompt: AgentQuickPrompt) {
    if (hasSelectedRef.current) return;
    hasSelectedRef.current = true;
    setIsDisabled(true);
    onSelect(quickPrompt.prompt, quickPrompt.title);
  }

  return (
    <div
      role="group"
      aria-label="Suggested prompts"
      className="flex flex-wrap gap-2"
    >
      {quickPrompts.map((quickPrompt, index) => (
        <button
          key={`${quickPrompt.title}-${index}`}
          type="button"
          disabled={isDisabled}
          title={quickPrompt.title}
          onClick={() => handleSelect(quickPrompt)}
          className={PILL_CLASS}
        >
          {quickPrompt.title}
        </button>
      ))}
    </div>
  );
}
